import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getFacilityBySlug, facilities } from '../data/facilities';
import { PageBanner } from '../components/PageBanner';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { KeyDetailsBlock } from '../components/KeyDetailsBlock';
import { ImageGallery } from '../components/ImageGallery';
import { RelatedPages } from '../components/RelatedPages';
export function FacilityDetail() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const facility = slug ? getFacilityBySlug(slug) : undefined;
  if (!facility) return <Navigate to="/facilities" replace data-id="element-854" />;
  const otherFacilities = facilities.filter(f => f.id !== facility.id).slice(0, 3).map(f => ({
    title: f.name,
    image: f.image,
    link: `/facilities/${f.id}`
  }));
  return <div className="w-full bg-club-canvas pb-24" data-id="element-855">
      <PageBanner title={facility.name} eyebrow={facility.category} image={facility.image} data-id="element-856" />

      <div className="max-w-7xl mx-auto px-4 mt-8" data-id="element-857">
        <Breadcrumbs items={[{
        label: 'Facilities',
        path: '/facilities'
      }, {
        label: facility.name
      }]} data-id="element-858" />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mt-8" data-id="element-859">
          <div className="lg:col-span-2 space-y-12" data-id="element-860">
            <section data-id="element-861">
              <h2 className="text-3xl mb-6" data-id="element-862">Overview</h2>
              <p className="text-lg text-club-ink/80 leading-relaxed" data-id="element-863">
                {facility.longDesc}
              </p>
            </section>

            <section data-id="element-864">
              <h2 className="text-3xl mb-6" data-id="element-865">Gallery</h2>
              <ImageGallery images={facility.images} data-id="element-866" />
            </section>
          </div>

          <div className="space-y-8" data-id="element-867">
            <KeyDetailsBlock details={facility.keyDetails} data-id="element-868" />

            <div className="bg-club-canvasAlt p-8 border border-club-border rounded-sm text-center" data-id="element-869">
              <h3 className="font-serif text-2xl mb-4 text-club-green" data-id="element-870">
                Need Assistance?
              </h3>
              <p className="text-sm text-club-ink/70 mb-6" data-id="element-871">
                Our staff is available to help you make the most of our
                facilities.
              </p>
              <button className="btn-secondary w-full" data-id="element-872">
                Contact Reception
              </button>
            </div>
          </div>
        </div>

        <RelatedPages title="Other Facilities" pages={otherFacilities} data-id="element-873" />
      </div>
    </div>;
}